/* @format */
import store from '@/stores';
import { ClientService } from '@/scripts/services/entities/client-service';
import EventBus from '@/scripts/event-bus';

/**
 * @param {import('vue-router').Route} to
 * @param {import('vue-router').Route} from
 * @param {function} next
 */
export async function accountActivateSubscriptionContactGuard(to, from, next) {
    const defaultRedirectPath = '/';

    const client = store?.state?.context?.client;
    const clientId = client?.id;
    const isAdmin = store.getters.isAdmin;
    const isClientUser = store.getters.isClientUser;

    if (isAdmin || !isClientUser) {
        return next(defaultRedirectPath);
    }

    const isLegacyAccess = await ClientService.isClientLegacyAccess(clientId);
    if (!isLegacyAccess) {
        EventBus.$emit('already-activated');
        return next(defaultRedirectPath);
    }

    next();
}
